module.exports = __webpack_public_path__ + "static/54-4-technologies-fueling-digital-transformation-bcbda31f4424b0276f3382dc0ddb569c.png";